export enum LanguageCode {
  English = 'en',
  Russian = 'ru',
  Korean = 'kr',
  Armenian = 'am',
  Azerbaijani = 'az',
  Spanish = 'es',
  Hindi = 'hi',
  Kyrgyz = 'kg',
  Kazakh = 'kz',
  Tajik = 'tj',
  Turkish = 'tr',
  Ukrainian = 'ua',
  Uzbek = 'uz',
  German = 'de',
  French = 'fr',
  Thai = 'th',
  Georgian = 'ge',
  Indonesian = 'idn',
}
